import Menu from "@/components/layout/menu.vue";
import Menu_Provider from "@/components/layout/menu_provider.vue";
import New_Menu from "@/components/layout/new_menu.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    Menu,
    Menu_Provider,
    New_Menu,
  },

  data: () => ({
    loaded_user: false
  }),
  created() {
    this.$store.dispatch("Authenticate/me").then((user)=>{
      this.loaded_user = true
    })

  },
  computed: {
    ...mapState({
      user: state => state.Authenticate.user,
    }),
    ...mapGetters({
      isLoggin: "Authenticate/isLoggedIn"
    })
  },
};
